// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client'
import type {
  SyncMapsData,
  SyncMapsResponses,
  SyncMapsErrors,
  StopRemoteSyncData,
  StopRemoteSyncResponses,
  StopRemoteSyncErrors,
  GetRemoteSyncData,
  GetRemoteSyncResponses,
  GetRemoteSyncErrors,
  StartRemoteSyncData,
  StartRemoteSyncResponses,
  StartRemoteSyncErrors,
} from './types.gen'
import { client as _heyApiClient } from './@tanstack/initializer'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Synchronize map data
 * Downloads the control data dump for the configured map schema from the backend and replaces the local map database. Runs synchronously: the request blocks until the sync finishes or the server side timeout (--timeout-s, 3600 s by default) elapses. By default the sync is skipped when the local data version matches the remote one or when the last sync is newer than the most recent configured sync time point.
 */
export const syncMaps = <ThrowOnError extends boolean = false>(options?: Options<SyncMapsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<SyncMapsResponses, SyncMapsErrors, ThrowOnError>({
    url: '/sync-maps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Stop the remote sync window
 * Closes the remote sync window so that data sync targets the local NAS again.
 */
export const stopRemoteSync = <ThrowOnError extends boolean = false>(
  options?: Options<StopRemoteSyncData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<StopRemoteSyncResponses, StopRemoteSyncErrors, ThrowOnError>({
    url: '/remote-sync',
    ...options,
  })
}

/**
 * Remote sync window status
 * Reports whether a remote sync window is currently active, together with the car to NAS data copy status read from the navigation API. An expired window is cleared and reported as inactive.
 */
export const getRemoteSync = <ThrowOnError extends boolean = false>(
  options?: Options<GetRemoteSyncData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetRemoteSyncResponses, GetRemoteSyncErrors, ThrowOnError>({
    url: '/remote-sync',
    ...options,
  })
}

/**
 * Start a remote sync window
 * Opens a remote sync window pointing at the configured VPN address, valid for sync.remote_ttl_m minutes. While the window is active, data sync targets the VPN address instead of the local NAS.
 */
export const startRemoteSync = <ThrowOnError extends boolean = false>(
  options?: Options<StartRemoteSyncData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<StartRemoteSyncResponses, StartRemoteSyncErrors, ThrowOnError>({
    url: '/remote-sync',
    ...options,
  })
}
